import * as angular from 'angular';

function cdnFilter() {
    return (resourceUrl: string) => {
        if (resourceUrl) {
            const cndUrl: string = siteCdnUrl;
            return `${window.location.protocol}//${cndUrl}${resourceUrl}`;
        }
    };
}

angular
    .module('app.common')
    .filter('cdn', [cdnFilter]);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.common/modules/common/filters/cdn.filter.ts